// extracted by mini-css-extract-plugin
export var callCard = "_qn-0";
export var callMessageButton = "_qn-1";
export var helpIcon = "_qn-3";
export var helpIconContainer = "_qn-4";
export var verticalDivider = "_qn-2";